<nav class="jump-nav" grooveSurface size="sm" aria-label="On this page">
  <span class="jump-nav-label">{{ label() }}</span>
  <ul class="jump-nav-list" role="list">
    @for (link of links(); track link.label) {
      <li class="jump-nav-item">
        @if (link.path) {
          <a
            class="groove-text-link groove-ring jump-nav-link-shell jump-nav-link-path"
            data-tone="accent"
            data-underline="hover"
            [routerLink]="link.path"
          >
            {{ link.label }}
          </a>
        } @else {
          <a
            class="groove-text-link groove-ring jump-nav-link-shell"
            data-tone="accent"
            data-underline="hover"
            routerLink="."
            [fragment]="link.fragment"
          >
            {{ link.label }}
          </a>
        }
      </li>
    }
  </ul>
</nav>
